export default function TabPanel({ children, value, index }) {
  if (value === index) {
    return <>{children}</>;
  }
  return null;
}
